// app/javascript/controllers/scroll_to_body_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        // scroll to top only if no hash is set!
        if (!window.location.hash) {
            window.scrollTo({top: 0, behavior: 'instant'})
        }
    }
}
